import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import cloneDeep from 'lodash/cloneDeep';
import { forceTypo, search, updateQuery } from '../../state/actions';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';
import { buildSearchUrl } from '../../state/utils';
import { getHighlightedWords } from './autoCorrectUtils';
import { StateType } from '../../../state/state.types';

const source = 'auto_correct';

const mapState = (state: StateType) => {
  const correctedQueryParams = cloneDeep(state.queryParams);
  if (state.results.autoCorrectedQuery) {
    correctedQueryParams.userQuery = state.results.autoCorrectedQuery;
    const correctedUrl = buildUrlWithParameters(
      buildSearchUrl(correctedQueryParams),
      {
        source,
      },
    );
    return {
      autoCorrectedQuery: state.results.autoCorrectedQuery,
      highlightedWords: getHighlightedWords(
        state.results.query,
        state.results.autoCorrectedQuery,
      ).map((item, index) => ({ ...item, key: index })),
      typoUrl: buildUrlWithParameters(buildSearchUrl(state.queryParams), {
        disable_autocorrect: true,
        source,
      }),
      query: state.results.query,
      correctedUrl,
    };
  }
};

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  onForceTypo() {
    dispatch(forceTypo());
    dispatch(search({ reason: 'autocorrect_zero' }));
  },
  onCorrectQuery(query: string) {
    dispatch(updateQuery(query));
    dispatch(search({ reason: 'autocorrect' }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
